import { render } from "./IntroView.vue?vue&type=template&id=4c5bfc00&scoped=true"
import script from "./IntroView.vue?vue&type=script&lang=js"
export * from "./IntroView.vue?vue&type=script&lang=js"

import "./IntroView.vue?vue&type=style&index=0&id=4c5bfc00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5bfc00"]])

export default __exports__